import { DOMAIN_ICONS, isDomainIconId, type DomainIconId } from './registry';

interface DomainIconProps {
  /** Registry id — option ids from the configs double as icon ids. */
  id: DomainIconId | string;
  /** Pixel size (width = height). Tailwind h-/w- classes override via CSS. */
  size?: number | string;
  className?: string;
  /** Accessible name; omit for decorative usage (renders aria-hidden). */
  title?: string;
  strokeWidth?: number | string;
}

/**
 * Renders a glyph from the domain icon registry. Unknown ids fall back to the
 * generic building so a stale DB string can never crash a card — the registry
 * completeness test keeps that fallback from hiding real gaps.
 */
export default function DomainIcon({ id, size = 20, className, title, strokeWidth = 1.7 }: DomainIconProps) {
  const Glyph = isDomainIconId(id) ? DOMAIN_ICONS[id] : DOMAIN_ICONS.building;
  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true })}
    />
  );
}
